import {getData, postUrlencodedData, api} from '../request';

export function getPagedQaList(index, size, callBack){
    getData(api.getQaList, {index: index, size: size})
        .then(res => {
            if (res.code === 200)
                callBack(res.data);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function deleteQa(id, callBack) {
    postUrlencodedData(api.deleteQa(id))
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function updateQa(data, callBack){
    postUrlencodedData(api.updateQa(data.id), data)
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function getQaDetail(id, callBack) {
    getData(api.getQa(id))
        .then(res => {
            if (res.code === 200)
                callBack(res.data);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function addQa(data, callBack) {
    postUrlencodedData(api.addQa, data)
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}
